<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <card>
                        <h4 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span> -
                            Общая информация</h4>
                        <form>
                            <div class="loader" v-if="waiting"></div>

                            <div class="row">
                                <div class="col-md-9">

                                    <h4 slot="header" class="card-title">
                                        Фрейм: <span v-if="object.src">
                                            <span class="inline-link">
                                                <span v-if="object.src_size >= 1"
                                                      class="bg-danger">{{ object.src_size }}Mb</span>
                                                <span v-else-if="object.src_size >= 0.5"
                                                      class="bg-warning">{{ object.src_size }}Mb</span>
                                                <span v-else>{{ object.src_size }}Mb</span>
                                                <a :href="object.src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                    </h4>

                                    <img v-if="object.src_full"
                                         id="preview-img" @click.prevent="openResource(object.src_full)"
                                         :src="object.src_full" class="device-block device1">

                                    <div>
                                        <input ref="imageFileInput" class="btn-file" type="file"
                                               @change="uploadFile($event, 'object_src')">
                                        <button type="button" class="btn btn-info btn-fill upload-button"
                                                @click="$refs.imageFileInput.click()">
                                            Загрузить
                                        </button>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </div>


                            <div class="clearfix"></div>

                        </form>
                    </card>
                </div>

                <div class="col-md-8" v-if="object.src_full">
                    <card>
                        <div class="row">
                            <div class="col-md-6" style="background: #C9D5DF;">

                                <!--                                <div id="frame-img" :style="{ background: '' }">-->

                                <!--                                </div>-->
                                <div class="img-wrap">
                                    <img id="frame-img"
                                         ref="img"
                                         :src="object.src_full" class="frame" alt="">

                                    <div class="frame-layouts" v-for="(pa, index) in object.params"
                                         v-if="pa.w && pa.h"
                                         v-bind:id="`pa${index}`"
                                         v-html="layout_html(index)" @click="selectLayout(index)">
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-5">
                                <h4 slot="header" class="card-title">
                                    Layouts
                                </h4>
                                <form>
                                    <div class="texts-buttons" v-if="object">
                                        <button v-for="(t, index) in object.layouts"
                                                type="button" class="btn btn-text btn-fill"
                                                :class="{ 'active' : index === active_layout }"
                                                @click="selectLayout(index)">Layout {{ index + 1 }}
                                        </button>
                                        <button type="button" class="btn btn-text btn-fill"
                                                @click="addLayout()">+
                                        </button>
                                        <button type="button" class="btn btn-text btn-fill"
                                                @click="save()">Обновить
                                        </button>

                                    </div>
                                    <div class="row frame-params" v-for="(rawData, index) in object.params"
                                         :class="{ 'active' : index === active_layout }">
                                        <div class="col-md-12">
                                            <code>"x": {{ object.layouts[index].x }},</code><br>
                                            <code>"y": {{ object.layouts[index].y }},</code><br>
                                            <code>"w": {{ object.layouts[index].w }},</code><br>
                                            <code>"h": {{ object.layouts[index].h }}</code><br>
                                        </div>
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Ширина фрейма в Figma"
                                                      v-model="rawData.original_w"
                                                      placeholder="">
                                            </fg-input>
                                            <fg-input type="text"
                                                      label="Высота фрейма в Figma"
                                                      v-model="rawData.original_h"
                                                      placeholder="">
                                            </fg-input>
                                            <fg-input type="text"
                                                      label="Ширина редактируемой области"
                                                      v-model="rawData.w"
                                                      placeholder="">
                                            </fg-input>
                                            <fg-input type="text"
                                                      label="Высота редактируемой области"
                                                      v-model="rawData.h"
                                                      placeholder="">
                                            </fg-input>
                                            <fg-input type="text"
                                                      label="Отступ сверху"
                                                      v-model="rawData.y"
                                                      placeholder="">
                                            </fg-input>
                                            <fg-input type="text"
                                                      label="Отступ слева"
                                                      v-model="rawData.x"
                                                      placeholder="">
                                            </fg-input>

                                        </div>
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Радиус верхний левый"
                                                      v-model="rawData.b_tl"
                                                      placeholder="">
                                            </fg-input>
                                            <fg-input type="text"
                                                      label="Радиус верхний правый"
                                                      v-model="rawData.b_tr"
                                                      placeholder="">
                                            </fg-input>
                                            <fg-input type="text"
                                                      label="Радиус нижний левый"
                                                      v-model="rawData.b_bl"
                                                      placeholder="">
                                            </fg-input>
                                            <fg-input type="text"
                                                      label="Радиус нижний правый"
                                                      v-model="rawData.b_br"
                                                      placeholder="">
                                            </fg-input>
<!--                                            <fg-input type="text"-->
<!--                                                      label="Z index"-->
<!--                                                      v-model="object.layouts[active_layout].z_index"-->
<!--                                                      placeholder="">-->
<!--                                            </fg-input>-->

                                            <div class="clearfix"></div>
                                            <button type="button" class="btn btn-remove"
                                                    @click="removeLayout(active_layout)">Удалить layout
                                            </button>
                                        </div>


                                    </div>


                                </form>
                            </div>
                        </div>

                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

const moment = require('moment')
const _ = require('lodash')
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
    name: 'EditAlbum',
    components: {
        Card,
    },
    data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            categories: [],
            active_layout: 0,
            data: {},
            object: {
                status: 0,
                category_id: 0,
                src: null,
                src_full: null,
                is_premium: 0,
                no_color: 1,
                sort: 1,
                layouts: [],
                params: []
            },
            default_layout: {
                w: null,
                h: null,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0
            },
            default_param: {
                original_w: null,
                original_h: null,
                w: null,
                h: null,
                x: 0,
                y: 0,
                b_tl: 0,
                b_tr: 0,
                b_br: 0,
                b_bl: 0,
            },
        }
    },
    created: function () {
        this.getCategories();
        this.addLayout(true);
    },
    computed: {
        graphicsUrl() {
            return this.$graphicsUrl
        },
    },
    methods: {
        goBack: function () {
            this.$router.push('/frames');
        },
        getCategories: function () {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/frames/categories`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    self.categories = JSON.parse(JSON.stringify(response.data));

                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        save: function () {
            let self = this;

            this.calculateParams();

            let i = this.active_layout;
            this.active_layout = -1;

            setTimeout(() => {

                this.active_layout = i;
            }, 100)



return

        },

        uploadFile: function (event, type) {
            let self = this;

            let formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            axios.post(
                `${this.$hostname}/admin/services/file/upload`,
                formData,
                {
                    params: {
                        file_type: type
                    },
                    headers: {
                        'Authorization': 'Bearer ' + this.token,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function (response) {

                self.waiting = false;

                let data = JSON.parse(JSON.stringify(response.data));

                self.object.src = data.url;
                self.object.src_full = data.url_full;
                self.object.src_size = data.filesize;

            })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error);
                });
        },
        layout_html(index) {
            let layoutModel = this.object.layouts[index];
            let rawData = this.object.params[index];

            let scale = 360 / parseFloat(rawData.original_w);

            let overlay = {
                w: rawData.w * scale,
                h: rawData.h * scale,
                x: rawData.x * scale,
                y: rawData.y * scale,
                b_tl: parseFloat(rawData.b_tl * scale).toFixed(2),
                b_tr: parseFloat(rawData.b_tr * scale).toFixed(2),
                b_br: parseFloat(rawData.b_br * scale).toFixed(2),
                b_bl: parseFloat(rawData.b_bl * scale).toFixed(2),
            }

            const colors = [
                'rgba(255, 0, 0, 0.4)',
                'rgba(0, 128, 0, 0.4)',
                'rgba(0, 0, 255, 0.4)',
                'rgba(255, 165, 0, 0.4)',
                'rgba(128, 0, 128, 0.4)',
                'rgba(0, 206, 209, 0.4)',
                'rgba(255, 192, 203, 0.4)',
                'rgba(255, 255, 0, 0.4)',
                'rgba(165, 42, 42, 0.4)',
                'rgba(128, 128, 128, 0.4)'
            ]

            let layout = `<div class="overlay ${ index === this.active_layout ? 'active' : '' }"></div>`;

            let style = ` style="position: absolute; background: ${colors[index] ? colors[index] : colors[0]}; top: ${overlay.y}px; left: ${overlay.x}px; width: ${overlay.w}px; height: ${overlay.h}px; border-radius: ${overlay.b_tl}px ${overlay.b_tr}px ${overlay.b_br}px ${overlay.b_bl}px; z-index: ${layoutModel.z_index}"`;

            layout = this.insertAt(layout, style, 5)

            return layout;
        },
        insertAt(str, sub, pos) {
            return `${str.slice(0, pos)}${sub}${str.slice(pos)}`;
        },
        openResource: function(url) {
            window.open(url, "_blank");
        },
        selectLayout(layout) {
            this.active_layout = layout;
        },
        addLayout(first = false) {
            this.object.layouts.push(JSON.parse(JSON.stringify(this.default_layout)))

            if (!first) {
                this.default_param.original_w = _.last(this.object.params).original_w
                this.default_param.original_h = _.last(this.object.params).original_h
            }

            this.object.params.push(JSON.parse(JSON.stringify(this.default_param)))
            this.active_layout = this.object.layouts.length - 1;
        },
        removeLayout(index) {
            let self = this;

            if (self.object.layouts.length === 1) {
                alert('Нельзя удалить последний layout')
                return;
            }

            if (confirm("Подтверждение удаления layout " + (parseInt(index) + 1))) {
                self.active_layout = 0;

                self.object.params = self.object.params.filter((t, i) => i !== index);
                self.object.layouts = self.object.layouts.filter((t, i) => i !== index);
            }
        },
        calculateParams: function() {

            for (let i = 0; i < this.object.layouts.length; i++) {

                let rawData = this.object.params[i];

                this.object.layouts[i] = {
                    w: parseFloat((parseFloat(rawData.w) / parseFloat(rawData.original_w))).toFixed(6),
                    h: parseFloat((parseFloat(rawData.h) / parseFloat(rawData.original_h))).toFixed(6),
                    x: parseFloat(parseFloat(rawData.x) / parseFloat(rawData.original_w)).toFixed(6),
                    y: parseFloat(parseFloat(rawData.y) / parseFloat(rawData.original_h)).toFixed(6),
                    b_tl: parseFloat(parseFloat(rawData.b_tl) / parseFloat(rawData.original_w)).toFixed(6),
                    b_tr: parseFloat(parseFloat(rawData.b_tr) / parseFloat(rawData.original_w)).toFixed(6),
                    b_br: parseFloat(parseFloat(rawData.b_br) / parseFloat(rawData.original_w)).toFixed(6),
                    b_bl: parseFloat(parseFloat(rawData.b_bl) / parseFloat(rawData.original_w)).toFixed(6),
                    //z_index: parseInt(this.object.layouts[i].z_index)
                }

            }

        },


    }
}

</script>
<style scoped>
.btn-save {
    width: 150px;
}

.buttons-block {
    padding-left: 20px !important;
}
.btn-info.btn-fill, .btn-info.btn-fill:active {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-top: 8px;
}

.checkbox-block {
    margin-top: 40px;
    margin-left: 40px;
}

.btn-file {
    display: none;
}

.image-block {
    max-width: 100%;
}

.form-check-inline {
    display: inline-block;
}

.label-checkbox {
    margin-right: 10px
}

.link {
    cursor: pointer;
    text-decoration: underline;
}

.card-body p {
    font-weight: 300;
    font-style: italic;
}

.card-body form {
    margin-top: 15px;
}

.device-block {
    position: relative;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
}

.inline-link span {
    padding: 3px;
    border-radius: 4px;
    font-size: 18px;
}

.bg-danger {
    background-color: rgba(255, 70, 50, 0.5) !important;
}

.device-block img {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 18px;
    top: 18px;
}

.device-block span {
    position: absolute;
    top: -30px;
    left: 5px;
}
.device1 {
    display: block;
    max-width: 100%;
    max-height: 100px;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    background-color: transparent;
    margin-top: 15px;
    margin-bottom: 15px;
}


.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}
.btn-delete {
    margin-right: 20px;
    opacity: 0.5;
}
.btn-delete, .btn-save, .btn-default {
    margin-top: 30px;
}
.img-wrap {
    position: relative;
    display: inline-block;
    width: 360px; /* или auto / 100% */
}
.frame-layouts {
    cursor: pointer;
}

.overlay {
    position: absolute;
    cursor: pointer;
}
.overlay.active {
    outline: 1px solid red;
}

.frame {
    display: block;
    width: 360px;
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
    background-color: transparent;
}
.calculate {
    margin-top: 23px;
}
.zoom-box {
    border: 2px solid #000;
    border-radius: 12px;
    pointer-events: none;
    z-index: 9999;
    /* для красоты можно добавить фон */
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}
.texts-buttons {
    margin-top: 30px;
}

.btn-text, .btn-text:active, .btn-text:hover {
    color: #000;
    background-color: #FFFFFF;
    border: 1px solid #000000;
    margin-right: 5px;
    margin-bottom: 5px;
}

.btn-text.active {
    color: #000;
    background-color: #D5C9E9;
    border: 1px solid #D5C9E9;
}

.btn-text:hover {
    opacity: 0.6;
}

.btn-text.control-btn {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
}
.frame-params {
    display: none;
}
.frame-params.active {
    display: flex;
}
.btn-remove, .btn-remove:active {
    color: rgba(255, 70, 50);
    border: 1px solid rgba(255, 70, 50);
    background-color: transparent;
    margin-top: 25px;
    float: right;
}


</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Calc.vue